module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



//////////////////
// WEBPACK FOOTER
// ./~/atoa/atoa.js
// module id = ./node_modules/atoa/atoa.js
// module chunks = 2